import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBookOpen, FaSchool, FaUserGraduate, FaUsers } from 'react-icons/fa';
import { useApp } from '../../context/AppContext';
import { enrollmentAPI, schoolAPI, studentAPI } from '../../utils/api';
import { DashboardChartGrid, KpiGrid, PortalHero } from '../../components_shared/PortalDashboard';

export default function HeadMasterDashboardPage() {
  const { user } = useApp();
  const navigate = useNavigate();
  const [schools, setSchools] = useState([]);
  const [students, setStudents] = useState([]);
  const [summary, setSummary] = useState({ totalEnrollment: 0, collectedSchools: 0, pendingSchools: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      schoolAPI.getAll(),
      studentAPI.getAll(),
      enrollmentAPI.getCollectionSummary(),
    ]).then(([schoolRes, studentRes, summaryRes]) => {
      setSchools(schoolRes.data || []);
      setStudents(Array.isArray(studentRes.data) ? studentRes.data : []);
      setSummary(summaryRes.data || {});
    }).finally(() => setLoading(false));
  }, []);

  const cards = useMemo(() => [
    { icon: <FaSchool />, label: 'Assigned Schools', value: schools.length, desc: 'Schools under your portal', className: 'eduss-dashboard-card-blue', onClick: () => navigate('/hm/students') },
    { icon: <FaUsers />, label: 'Students', value: students.length, desc: 'Student records in assigned schools', className: 'eduss-dashboard-card-green', onClick: () => navigate('/hm/students') },
    { icon: <FaBookOpen />, label: 'Manual Enrollment', value: Number(summary.totalEnrollment || 0).toLocaleString(), desc: 'Class-wise enrollment captured', className: 'eduss-dashboard-card-yellow', onClick: () => navigate('/hm/enrollment') },
    { icon: <FaUserGraduate />, label: 'Pending Schools', value: summary.pendingSchools || 0, desc: 'Schools waiting for enrollment', className: 'eduss-dashboard-card-green', onClick: () => navigate('/hm/enrollment') },
  ], [schools.length, students.length, summary, navigate]);

  const charts = useMemo(() => [
    {
      title: 'School Records',
      caption: 'Assigned view',
      type: 'bar',
      data: [
        { name: 'Schools', value: schools.length },
        { name: 'Students', value: students.length },
        { name: 'Pending', value: Number(summary.pendingSchools || 0) },
      ],
      color: '#0f6fad',
    },
    {
      title: 'Enrollment Activity',
      caption: 'Manual entry',
      type: 'line',
      data: [
        { name: 'Collected', value: Number(summary.collectedSchools || 0) },
        { name: 'Pending', value: Number(summary.pendingSchools || 0) },
        { name: 'Enrollment', value: Number(summary.totalEnrollment || 0) },
      ],
      color: '#10ac84',
    },
  ], [schools.length, students.length, summary]);

  return (
    <div className="eduss-dashboard">
      <PortalHero title="Head Master Dashboard" subtitle={`Welcome, ${user?.username || 'Head Master'}. Manage students and enrollment for your assigned schools.`} />
      <KpiGrid cards={cards} loading={loading} />
      <DashboardChartGrid charts={charts} />

      <div className="eduss-dashboard-content">
        <h2>Assigned Schools</h2>
        <table className="mini-info-table" style={{ width: '100%' }}>
          <tbody>
            {schools.map(school => (
              <tr key={school.id}>
                <th>{school.school_name || school.name}</th>
                <td>{school.semis_code || school.code}</td>
                <td>{school.taluka_name || '-'}</td>
              </tr>
            ))}
            {!loading && !schools.length && <tr><td>No schools assigned yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
